import React from 'react';
import './Vision.css';
import Footer from '../components/home/Footer';

const Vision = () => {
  return (
    <div className="vision-page">
      {/* Hero Section */}
      <section className="vision-hero">
        <div className="vision-container">
          <h1>Our Vision</h1>
          <p>
            Become a trusted global platform where startups, entrepreneurs, talented professionals, co-founders, and investors connect and build meaningful business opportunities together.
          </p>
        </div>
      </section>

      {/* Vision Statement */}
      <section className="vision-section">
        <div className="vision-container">
          <h2>Vision Statement</h2>
          <p>
            At CofounderHubs, our vision is to become a trusted global platform where startups, entrepreneurs, talented professionals, co-founders, and investors can connect and build meaningful business opportunities together.
          </p>
          <p>
            We aim to make finding the right people, opportunities, and resources for building a startup faster, easier, and more accessible.
          </p>
        </div>
      </section>

      {/* Mission Statement */}
      <section className="vision-section">
        <div className="vision-container">
          <h2>Mission Statement</h2>
          <p>
            Our mission is to simplify the startup ecosystem by bringing founders, co-founders, candidates, investors, and companies together on one platform.
          </p>
          <p>
            We help startups find the right co-founders and team members, recruit qualified candidates efficiently, promote job opportunities, discover potential investors and business connections, and access recruitment support when needed. Our goal is to reduce the time and difficulty involved in finding the right people and opportunities, so startups can focus on building, growing, and succeeding.
          </p>
        </div>
      </section>

      {/* Purpose */}
      <section className="vision-section">
        <div className="vision-container">
          <h2>Business Purpose</h2>
          <p>
            CofounderHubs helps startups and entrepreneurs discover suitable co-founders, candidates, investors, and business opportunities in one platform — as a networking, co-founder discovery, talent and recruitment, job posting, and investor-connection platform, with optional recruitment support for companies.
          </p>
          <p>
            Companies can post hiring positions using clear pricing plans: Basic job posting (Free), Enhanced job posting ($29), and Premium job posting ($99). CofounderHubs can also help companies identify, screen, and connect with suitable candidates for open roles.
          </p>
        </div>
      </section>

      {/* Core Values */}
      <section className="vision-section">
        <div className="vision-container">
          <h2>Core Values</h2>
          
          <div className="values-list">
            <div className="value-item">
              <h3>Innovation</h3>
              <p>We keep improving how startups discover co-founders, talent, investors, and opportunities — with clearer profiles, better search, and practical hiring tools.</p>
            </div>

            <div className="value-item">
              <h3>Global Access</h3>
              <p>Great teams and partnerships can form across cities, countries, and time zones. Location should not block the right connection.</p>
            </div>

            <div className="value-item">
              <h3>Collaboration</h3>
              <p>We help founders, candidates, and companies build trust and collaborate — through profiles, feed conversations, job posts, and real connections.</p>
            </div>

            <div className="value-item">
              <h3>Trust</h3>
              <p>Transparent profiles, honest matching, and respect for privacy in every connection and conversation.</p>
            </div>

            <div className="value-item">
              <h3>Inclusivity</h3>
              <p>Equal opportunity to find the right people and opportunities, regardless of location, background, or network size.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Strategic Goals */}
      <section className="vision-section">
        <div className="vision-container">
          <h2>Strategic Goals</h2>
          
          <div className="goals-list">
            <div className="goal-item">
              <h3>1. Co-Founder Discovery</h3>
              <p>Help startups search for and connect with potential co-founders who match their skills, interests, and goals.</p>
            </div>

            <div className="goal-item">
              <h3>2. Talent & Recruitment</h3>
              <p>Make it easier for startups to find suitable candidates and recruit qualified people for open positions.</p>
            </div>

            <div className="goal-item">
              <h3>3. Clear Job Posting Plans</h3>
              <p>Offer straightforward job posting options — Basic (Free), Enhanced ($29), and Premium ($99) — so companies can promote open roles with clarity.</p>
            </div>

            <div className="goal-item">
              <h3>4. Investor Connections</h3>
              <p>Help startups discover and connect with potential investors and relevant business opportunities.</p>
            </div>

            <div className="goal-item">
              <h3>5. Recruitment Support</h3>
              <p>Provide recruitment partner support when companies need help identifying, screening, and connecting with suitable candidates.</p>
            </div>

            <div className="goal-item">
              <h3>6. Community Trust</h3>
              <p>Grow a community where founders, professionals, and companies share ideas, ask for advice, and build trust before collaborating.</p>
            </div>

            <div className="goal-item">
              <h3>7. Global Reach</h3>
              <p>Expand access so startups everywhere can find the right people and opportunities more efficiently.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Long-Term Vision */}
      <section className="vision-section">
        <div className="vision-container">
          <h2>Long-Term Vision (5-10 Years)</h2>
          
          <div className="longterm-list">
            <div className="longterm-item">
              <h3>Trusted Global Hub</h3>
              <p>Become a trusted global platform for startups, co-founders, talent, and investors to connect and build together.</p>
            </div>

            <div className="longterm-item">
              <h3>Faster Access to the Right People</h3>
              <p>Make finding co-founders, candidates, investors, and opportunities faster, easier, and more accessible for startups worldwide.</p>
            </div>

            <div className="longterm-item">
              <h3>From Connection to Growth</h3>
              <p>Support the early company journey: form a team, hire talent, promote roles, and explore investor and business connections.</p>
            </div>

            <div className="longterm-item">
              <h3>Global Startup Network</h3>
              <p>Build a worldwide community where startups connect with intention — not by chance or proximity alone.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Target Market */}
      <section className="vision-section">
        <div className="vision-container">
          <h2>Target Market</h2>
          
          <div className="market-list">
            <div className="market-item">
              <h3>Startups & Entrepreneurs</h3>
              <p>Founders and early-stage companies looking for co-founders, talent, investors, and business opportunities.</p>
            </div>

            <div className="market-item">
              <h3>Co-founders & Professionals</h3>
              <p>Skilled professionals seeking to join founding teams or contribute to ambitious startups.</p>
            </div>

            <div className="market-item">
              <h3>Candidates & Talent</h3>
              <p>People looking for open roles at startups, and companies seeking qualified candidates for hiring positions.</p>
            </div>

            <div className="market-item">
              <h3>Investors & Companies</h3>
              <p>Investors exploring startup connections, and companies that need job posting tools or recruitment support.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Conclusion */}
      <section className="vision-section">
        <div className="vision-container">
          <h2>Conclusion</h2>
          <p>
            CofounderHubs is committed to helping startups connect with the right people and resources more easily and efficiently — as a networking, co-founder discovery, talent and recruitment, job posting, and investor-connection platform, with recruitment support when needed.
          </p>
          <p>
            Our vision is to become a trusted global platform where startups, entrepreneurs, professionals, co-founders, and investors build meaningful opportunities together. Our mission is to simplify that journey so founders can focus on building, growing, and succeeding.
          </p>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Vision;
